<div class="dialog-top">
  <h2 mat-dialog-title>{{ 'Tags' | translate }}</h2>
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <table mat-table [dataSource]="dataSource" matSort>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Name' | translate }}</th>
      <td mat-cell *matCellDef="let tag">{{ '['+tag.name+']' }}</td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> {{ 'Description' | translate }} </th>
      <td mat-cell *matCellDef="let tag" > {{ tag.description }}</td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let tag" class="d-flex flex-row align-items-center gap-3">
        <mat-icon [matTooltip]="tag.formattedLocations" matTooltipClass="mat-custom-tooltip">info_outline</mat-icon>
        <div matTooltip="{{ 'Copy' | translate }}">
          <button mat-icon-button (click)="copyTag(tag.name)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let tag; columns: displayedColumns" class="table-row"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="99">{{ 'No items to display' | translate }}</td>
    </tr>
  </table>
  <mat-paginator [length]="totalItems" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true"></mat-paginator>
</mat-dialog-content>
